<template>
  <el-tabs v-model="selectedTab">
    <el-tab-pane
      name="simple"
      label="簡易"
      :lazy="true"
    >
      <simple-check
        v-loading="instrumentLoading"
        :areaList="areaList"
        :areaData="areaDataList"
      />
    </el-tab-pane>
    <el-tab-pane
      name="detailed"
      label="詳細"
      :lazy="true"
    >
      <detail-check
        v-loading="instrumentLoading"
        :areaList="areaList"
        :areaData="areaDataList"
      />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import manualProjectMixin from '@/lib/base/manualProject';
export default {
  mixins: [manualProjectMixin],
  components: {
    DetailCheck: () => import('@/components/manual/UploadFrequencyCheck'),
    SimpleCheck: () => import('@/components/manual/SimpleFrequencyCheck'),
  },
  computed: {
    selectedProject() {
      return this.$store.getters['project/selectedProject'];
    },
  },
  data(){
    return {
      selectedTab: 'detailed',
      instrumentLoading: true,
      instrumentsInGroup: [],
      originInstrumentList: [],
      areaDataList: [],
      areaList: [],
    };
  },
  async mounted(){
    await this.load();
  },
  methods: {
    async load(){
      console.log('load');
      this.instrumentLoading = true;
      const res = await this.$axios({
        category: 'manual',
        method: 'get',
        apiName: `getManualInstrument/${this.manualProjectId}`,
      });
      this.originInstrumentList = res.data;

      await this.getGroup();

      await this.getOutput();

      this.areaDataList = this.transformToAreaData(this.originInstrumentList, this.outputList);

      this.areaList = this.areaDataList.map(ele=>ele.areaName);

      console.log(this.originInstrumentList);
      console.log(this.areaDataList);

      this.instrumentLoading = false;
    },

    async getOutput(){
      const res = await this.$axios({
        category: 'manual',
        method: 'get',
        apiName: `getAllManualInstrumentOutput/${this.manualProjectId}`,
      });

      this.outputList = res.data;
    },

    async getGroup(){
      let res = await this.$store
        .dispatch('data/getProjectInstrumentGroupList', {
          projectId: this.manualProjectId,
        });
      this.instrumentGroupList = res;
    },

    /**
     * 將 API 回傳的陣列轉成前端用的 areaData 結構
     * @param {Array} instrumentList - API result（多筆）
     * @param {string} [areaNameOverride] - 可選，指定 areaName
     * @returns {Object} areaData
     */
    transformToAreaData(instrumentList, outputList) {
      if (!Array.isArray(instrumentList)) throw new Error('instrumentList 必須是陣列');

      // 轉本地日期（YYYY-MM-DD）
      const pad2 = (n) => String(n).padStart(2, '0');
      const toLocalYMD = (input) => {
        if (!input) return '';
        const d = new Date(input);                  // 以本地時區解析
        if (isNaN(d)) return String(input);
        return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
      };

      const areaMap = new Map();    // key: areaName → { areaName, stationMap }

      for (const item of instrumentList) {
        const areaName    = item.area;
        const stationName = item.station;
        const instrumentTypeName = item?.instrument_type?.name;
        let instrumentName = item?.data[0]?.name ?? '未知儀器';

        const timeoutSetting = (item.timeoutSetting || []).map(s => ({
          start_date: toLocalYMD(s.start_date),
          end_date:   toLocalYMD(s.end_date),
          settingType: s.settingType ?? '',
          frequency_unit: s.frequency_unit ?? '',
          frequency: s.frequency ?? 0,
        }));

        // NEW：若此儀器沒有任何 timeout 設定，整個儀器直接略過
        if (timeoutSetting.length === 0) {
          continue;
        }

        let instrumentOutputList = outputList
          .filter(output => output.name === instrumentName)
          .map(output => ({ TIMESTAMP: output.TIMESTAMP }));

        // CHG：更安全的 includes（避免 instrumentTypeName 為 undefined 時報錯）
        if ((instrumentTypeName || '').includes('SIS')) {
          const instrumentGroup = this.instrumentGroupList
            .find(ele => ele.instrumentList.find(ins => ins.instrument === item._id));
          instrumentName = instrumentGroup?.name;
        }

        const instrument = {
          name: instrumentName,
          outputs: instrumentOutputList,
          timeoutSetting,
        };

        if(!areaMap.has(areaName)){
          const _stationMap = new Map(); // key: stationName → { stationName, instruments: [] }
          areaMap.set(areaName, { areaName, stationMap: _stationMap });
        }

        const stationMap = areaMap.get(areaName).stationMap;

        if (!stationMap.has(stationName)) {
          stationMap.set(stationName, { stationName, instruments: [instrument] });
        } else {
          if(!stationMap.get(stationName).instruments.find(ins => ins.name === instrumentName)) stationMap.get(stationName).instruments.push(instrument);
        }
      }

      const areaData = Array.from(areaMap.values()).map(area=>{
        return {
          areaName: area.areaName,
          stations: Array.from(area.stationMap.values()).filter(s => s.instruments.length > 0),
        };
      });
    
      return areaData;
    },

    
  },
};
</script>
